module.exports = __webpack_public_path__ + "img/housing.a506c68f.png";